import breadcrumbs from './breadcrumbs';
import multiPlanCrumb from './multiPlanCrumb';

const toLoad = [
  breadcrumbs,
  multiPlanCrumb
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
